import { Component, Input } from "@angular/core";
import { AddTeamWorkflowStepBaseComponent } from "app/features/people/teams/add-team-workflow/add-team-workflow-step-base.component";

@Component({
    selector: "adapt-add-team-create-team-button",
    templateUrl: "./add-team-create-team-button.component.html",
    styleUrl: "./add-team-create-team-button.component.css",
    standalone: false,
})
export class AddTeamCreateTeamButtonComponent {
    @Input() public instance!: AddTeamWorkflowStepBaseComponent;
}
